import { LowerCasePipe } from '@angular/common';
import { Component, effect, inject, input, linkedSignal, signal } from '@angular/core';
import { FormArray, FormControl, ReactiveFormsModule } from '@angular/forms';
import { BrnSelectImports } from '@spartan-ng/brain/select';
import { HlmAutocompleteImports, provideHlmAutocompleteConfig } from '@spartan-ng/helm/autocomplete';
import { HlmButtonGroupImports } from '@spartan-ng/helm/button-group';
import { HlmFieldImports } from '@spartan-ng/helm/field';
import { HlmSelectImports } from '@spartan-ng/helm/select';

import { FamilleLivrables } from '../../../../référentiel-métier/référentiel-métier-périmètre/perimetre-metier/models/famille-livrables.model';
import { FamilleLivrablesStore } from '../../../../référentiel-métier/référentiel-métier-périmètre/perimetre-metier/store/famille-livrables.store';
import { ButtonAddNewComponent } from '../../../../shared/components/button-add-new/button-add-new.component';
import { ExpansionPanel } from '../../../../shared/components/expansion-panel/expansion-panel.component';
import { FormControlNames } from '../../../models/form-control-names.model';
import { DetailLivrablesFormGroup } from '../detail-form-groups.types';
import { EtapeDetailFormService } from '../étape-detail-form.service';
import { Référentiel } from '../../../../administration/gestion-référentiels/models/référentiel.model';
import { ReferentielStore } from '../../../../administration/gestion-référentiels/store/referentiel.store';

@Component({
  selector: 'app-detail-livrables',
  imports: [
    ButtonAddNewComponent,
    LowerCasePipe,
    ExpansionPanel,
    HlmSelectImports,
    BrnSelectImports,
    HlmButtonGroupImports,
    HlmAutocompleteImports,
    ReactiveFormsModule,
    HlmFieldImports,
    HlmButtonGroupImports,
  ],
  templateUrl: './detail-livrables.component.html',
  providers: [
    provideHlmAutocompleteConfig({
      transformOptionToString: (option: FamilleLivrables) => option.nom,
      transformValueToSearch: (option: FamilleLivrables) => option.nom,
    }),
  ],
})
export class DetailLivrablesComponent {
  readonly #familleLivrablesStore = inject(FamilleLivrablesStore);
  readonly #etapeFormService = inject(EtapeDetailFormService);
  readonly #referentielStore = inject(ReferentielStore);

  readonly form = input.required<DetailLivrablesFormGroup>();
  readonly referentiel = input.required<Référentiel>();

  readonly famillesLivrablesFiltrees = linkedSignal(() => this.#familleLivrablesStore.entities());
  readonly traductions = linkedSignal(() => this.referentiel().metadonnees.traductions);

  protected readonly _referentiels = linkedSignal(() => this.#referentielStore.referentielsActifs());
  #referentielFiltre = signal<Référentiel | null>(null);

  public readonly search = signal('');

  constructor() {
    effect(() => {
      const referentiel = this.referentiel();

      const referentielFiltre = this.#referentielFiltre();
      this.#familleLivrablesStore.charger({
        idCartographie: referentiel.idCartographie,
        idRéférentiel: referentielFiltre?.id,
      });
    });
  }
  setReferentiel(referentiel: Référentiel) {
    this.#referentielFiltre.set(referentiel);
  }
  ajouterFamille() {
    this.#etapeFormService.ajouterFamilleLivrables();
  }

  filterFamilleLivrables(search: string) {
    const familles = this.#familleLivrablesStore.entities();

    if (!search) this.famillesLivrablesFiltrees.set(familles);

    this.famillesLivrablesFiltrees.set(familles.filter((x) => x.nom.toLowerCase().includes(search.toLowerCase())));
  }

  get famillesLivrables() {
    return this.form().get(FormControlNames.FAMILLES_LIVRABLES) as FormArray<FormControl>;
  }
}
